/*feeds mixin*/

// vuex
import { mapGetters } from "vuex";

//helpers


export const threads = {
  computed: {
    ...mapGetters([
      "loading",
      "feeds",
      "hasSearch",
      "mainFeeds", 
      "meta"
    ]),
    showPagination() {
      return !Object.keys(this.mainFeeds).length;
    },
    showNotFound() {
      return !Object.keys(this.mainFeeds).length && this.hasSearch;
    },
  },
  methods: {
    getPage() {
      let data = null;
      data = this.mainFeeds
      /*if (!this.hasSearch) {
        data = this.mainFeeds.slice(
          (this.getStartPage() - 1) * this.pageSize, this.currentPage * this.pageSize
        );
      } else {
        data = this.mainFeeds.slice(
          0, this.mainFeeds.length
        );
      }*/
       this.page = []
      data.map((it, id) => this.page[id] = [it]);
      console.log('page', this.page)
    },
    isLoadAdditional(feeds) {
      return feeds.some(elem => !elem.additional);
    },
    setPage(page) {
      this.currentPage = page;
    },
    getStartPage() {
      if (this.hasSearch) {
        return 1;
      }

      return this.currentPage;
    }
  },
  watch: {
    mainFeeds(value) {
        this.getPage();
    }
  },
};
